<template>
  <div>
    <div class="content py-5 px-6 mx-auto" style="width: 900px">
      <vs-row>
        <vs-col vs-w="10"></vs-col>
        <vs-col vs-w="2">
          <vs-button
            id="printPageButton"
            type="flat"
            icon-pack="feather"
            icon="icon-printer"
            @click="print()"
          >
            พิมพ์
          </vs-button>
        </vs-col>
      </vs-row>
      <header>
        <vs-row class="mt-5" vs-type="flex">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="text-center py-5"
          >
            <img
              class="-mt-2 mr-5"
              src="../../../../src/assets/excise/header_image.jpg"
              width="100%"
              height="full"
            />
          </vs-col>
        </vs-row>
        <vs-row class="-mt-4 mb-10 pr-10 text-right">
          <vs-col >
            {{reparationCode}}
          </vs-col>
        </vs-row>
      </header>
      <div class="content-block">
        <h3 align="center">แบบฟอร์มการแจ้งซ่อม</h3>
        <p class="mt-5">
          เรียน สรรพสามิตพื้นที่
        </p>
        <p class="mt-5">
          ส่วนที่ 1 ผู้ยื่นคำขอ(เจ้าของเรือ)
        </p>
        <vs-divider position="center"></vs-divider>
        <h5 class="mt-8">1.ผู้ยื่นคำขอ (เจ้าของเรือ)</h5>
        <vs-row class="mt-5 ml-10">
          <div class="flex">
            <vs-radio
              disabled
              class="mr-5"
              v-model="checkbox"
              vs-value="chkPerson"
              >บุคคลธรรมดา</vs-radio
            >
            <vs-radio
              disabled
              class="mr-5"
              v-model="checkbox"
              vs-value="chkLegal"
              >นิติบุคคล</vs-radio
            >
            <vs-radio
              disabled
              class="mr-10"
              v-model="checkbox"
              vs-value="chkOther"
              >หน่วยงานราชการอื่นๆ</vs-radio
            >
            <p class="mt-2 mx-2" v-show="checkbox == 'chkOther'">ระบุ</p>
            <vs-input disabled class="w-auto" v-show="checkbox == 'chkOther'" />
          </div>
        </vs-row>
        <vs-row class="mt-5">
          <vs-col vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>
              ชื่อ : {{info.personType == "นิติบุคคล" ? info.certificateOperateName : `${info.title} ${info.firstName}  ${info.lastName}`}}
            </p></vs-col
          >
        </vs-row>
        <vs-row class="mt-5">
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>
              เลขบัตรประชาชน / เลขนิติบุคคล :
              {{ formateCardNumber(info.cardNumber) }}
            </p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12" v-if="info.personType == 'นิติบุคคล'"
            ><p>
              ที่อยู่/ที่ตั้งสำนักงานใหญ่เลขที่ :
              {{ info.registrationOffice }}
            </p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>รหัสไปรษณีย์ : {{info.personType == "นิติบุคคล" ? info.certificatePostalCode : info.postalCode }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>ชื่ออาคาร : {{ info.buildingName }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>เลขที่ : {{ info.address }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>ชั้นที่ : {{ info.floor }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>หมู่ : {{info.personType == "นิติบุคคล" ? info.certificateVillageNumber : info.villageNumber }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>ตรอก/ซอย : {{info.personType == "นิติบุคคล" ? info.certificateLane : info.lane }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>ถนน : {{info.personType == "นิติบุคคล" ? info.certificateRoad : info.road }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>ตำบล : {{info.personType == "นิติบุคคล" ? info.certificateDistrict : info.district }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>อำเภอ/เขต : {{info.personType == "นิติบุคคล" ? info.certificateDistrict : info.district }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>จังหวัด : {{info.personType == "นิติบุคคล" ? info.certificateProvince : info.province }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>โทรศัพท์ : {{ info.personType == "นิติบุคคล" ? info.certificatePhoneNumber :info.phoneNumber }}</p></vs-col
          >
          <vs-col class="mb-2" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12"
            ><p>อีเมล : {{ info.personType == "นิติบุคคล" ? info.certificateEmail : info.email }}</p></vs-col
          >
        </vs-row>
        <vs-divider position="center"></vs-divider>
        <h5 class="mt-8">ส่วนที่ 2.รายงานการแจ้งซ่อม</h5>
        <vs-row class="mt-5 mb-5">
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>
              ชื่อเรือ :
              {{vessel.name}}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>
              หมายเลขทะเบียนเรือ :
              {{vessel.registrationNumber}}
            </p>
          </vs-col>
        </vs-row>
        <vs-divider class="mt-20" position="center"></vs-divider>
      </div>

      <div class="content-block">
        <h5 class="mt-20 mb-10">ส่วนที่ 3.อุปกรณ์ที่ต้องการแจ้งซ่อม</h5>
        <table style="width: 100%" class="mt-5">
          <tr>
            <th>รายการอุปกรณ์ที่ได้รับ</th>
            <th>จำนวน</th>
            <th>หมายเลขซีเรียล</th>
          </tr>
          <tr v-for="item in accessories" :key="item">
            <td>{{item.name}}</td>
            <td style="text-align: center;">{{item.amount}}</td>
            <td style="text-align: center;">{{item.serialNumber}}</td>
          </tr>
        </table>

        <vs-divider position="center" class="mb-10 mt-10"></vs-divider>

        <div class="mt-5 mb-5">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            จึงเรียนมาเพื่อโปรดพิจารณา
          </p>
        </div>

        <vs-row class="mb-10 mt-20">
          <!-- <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p class="ml-10">
              ลงชื่อ...........................................................ผู้ยื่นคำขอ
            </p>
            <br />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p>(...........................................................)</p>
            <br />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p>วันที่.........../............/...........</p>
          </vs-col> -->

                    <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-10"
            v-if="companySealImage"
          >
            <img :src="companySealImage" height="100" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <img
              :src="this.imageSignatureUserUrl"
              width="25%"
              v-if="imageSignatureUserUrl"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p>
              ลงชื่อ
              ........................................................................ผู้ยื่นคำขอ
            </p>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p v-if="checkbox == 'chkPerson'">
              ( {{ info.title }}{{ info.firstName }} {{ info.lastName }} )
            </p>
            <p v-else>( {{ info.certificateOperateName }} )</p>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>วันที่ {{ formateDate(info.createdAt) }}</p>
          </vs-col>
        </vs-row>

        <!-- <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p class="ml-10">
              ลงชื่อ...........................................................(เจ้าหน้าที่)
            </p>
            <br />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p>(...........................................................)</p>
            <br />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p>วันที่.........../............/...........</p>
          </vs-col>
        </vs-row> -->
      </div>

      <footer>
        <vs-row class="my-5" vs-type="flex">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="text-center py-5"
          >
            <img
              class="-mt-2 mr-5"
              src="../../../../src/assets/excise/footer_image.jpg"
              width="100%"
              height="full"
            />
          </vs-col>
        </vs-row>
      </footer>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ENDPOINT } from "../../../constants/endpoint";
import _ from "lodash";

export default {
  name: "AddVessel",
  data() {
    return {
      info:{},
      vessel: {},
      accessories:null,
      checkbox: null,
      registrationAt: null,
      imageSignatureUserUrl: null,
      imageSignatureSupervisorUrl: null,
      imageSignatureObserverUrl: null,
      companySealImage: null,
    };
  },
  mounted() {
        this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch(
        `reparations/setVesselReparationById`,
        this.$route.params.id
      );

      console.log("selectedReparation ", this.$store.state.reparations.selectedReparation);
      const reparation = this.$store.state.reparations.selectedReparation
      this.reparationCode = reparation.reparationCode

      console.log("this reparation :", reparation);

      this.info = reparation.reparationByUserId
      this.vessel = reparation.vessel;
      console.log("this is info :", this.info.personType);
      console.log("this is vessel :", this.vessel);

      this.info.personType == "บุคคลทั่วไป"
        ? (this.checkbox = "chkPerson")
        : this.info.personType == "นิติบุคคล"
        ? (this.checkbox = "chkLegal")
        : (this.checkbox = "chkOther");

        this.accessories = reparation.accessories


      if (reparation.signatures.lenght != 0) {
        for (const signature of reparation.signatures) {
          if (signature.type == "ผู้ยื่นคำขอ") {
            this.imageSignatureUserUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          } else if (signature.type == "เจ้าพนักงานสรรพสามิต") {
            this.imageSignatureSupervisorUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          } else if (signature.type == "ผู้บริหาร") {
            this.imageSignatureObserverUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
        }
      }

      const companySeal =  this.checkbox != "chkPerson" && _.find(reparation.createdBy.documents, { 'type': 8 });
      if (companySeal) {
        this.companySealImage = ENDPOINT.GET_IMAGE_COMPANY_SEAL + companySeal.fileName
      }

    },
    formateDate(date) {
      return date && moment(date).add(543, 'year').format('DD/MM/YYYY');
    },
    print() {
      window.print();
    },
    formateCardNumber(cardNumber) {
      return (
        cardNumber &&
        `${cardNumber.substring(0, 1)}-${cardNumber.substring(
          1,
          2
        )}${cardNumber.substring(2, 3)}${cardNumber.substring(
          3,
          4
        )}${cardNumber.substring(4, 5)}-${cardNumber.substring(
          5,
          6
        )}${cardNumber.substring(6, 7)}${cardNumber.substring(
          7,
          8
        )}${cardNumber.substring(8, 9)}${cardNumber.substring(
          9,
          10
        )}-${cardNumber.substring(10, 11)}${cardNumber.substring(
          11,
          12
        )}-${cardNumber.substring(12, 13)}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-color: white;
}

.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}

@page {
  // size: A4;
  // margin: 11mm 17mm 17mm 17mm;
  size: auto;
  margin: 0mm;
}

@media print {
  #printPageButton {
    display: none;
  }

  footer {
    position: fixed;
    bottom: 0;
  }

  header {
    position: fixed;
    top: 0;
  }
  .content-block {
    padding-top: 170px;
  }
  .content-block,
  p {
    page-break-inside: avoid;
  }
}
table {
  border-collapse: collapse;
  width: 100%;
}
th {
  text-align: center;
}
td,
th {
  border: 1px solid #868583;
  padding: 12px;
}
</style>
